<template>
  <div class="position-relative slides primary">
    <div v-if="items.length" class="slides-fade"></div>
    <transition name="fade">
      <div v-if="items.length">
        <hooper-container
          class="slides-container"
          style="height: auto"
          ref="carousel"
          :wheelControl="false"
          :mouseDrag="items.length > 1"
          :touchDrag="items.length > 1"
          :infiniteScroll="items.length > 1"
          :autoPlay="true"
          :playSpeed="4000"
          :transition="500"
        >
          <hooper-slide
            class="item"
            v-for="(
              { img_desktop, img_mobile, link, target }, keySlide
            ) in items"
            :key="keySlide"
          >
            <a v-if="link" :href="link" :target="target ? '_blank' : '_self'">
              <img
                :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
                class="d-block item-img"
                width="100%"
              />
            </a>

            <img
              v-else
              :src="files + (xs && img_mobile ? img_mobile : img_desktop)"
              class="d-block item-img"
              width="100%"
            />
          </hooper-slide>
        </hooper-container>
      </div>
    </transition>
  </div>
</template>

<script>
const _config = {
  mod: "slides",
};

export default {
  data: () => ({
    carouselData: 0,
  }),
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
    xs() {
      return this.$vuetify.breakpoint.xsOnly;
    },
  },
  mounted() {
    this.$rest(_config.mod).get();
  },
  components: {},
};
</script>

<style lang="scss" scoped>
.slides-fade {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1;
  pointer-events: none;
}
.slides {
  position: absolute;
  top: 0;
  left: 0;
  height: 100vh;
  aspect-ratio: 1920 / 998;
  width: 100%;
  @media (max-width: 1260px) {
    height: auto;
  }
  @media screen and (max-width: 600px) {
    aspect-ratio: 600 / 600;
  }

  .item {
    &-img {
      height: 100vh;
      aspect-ratio: 1920 / 998;
      object-fit: cover;
      -o-object-fit: cover;
      @media (max-width: 1260px) {
        height: 100%;
      }

      @media screen and (max-width: 600px) {
        aspect-ratio: 600 / 600;
      }
    }
  }

  &-nav {
    height: 0;
    left: 0;
    margin-top: -25px;
    position: absolute;
    top: 50%;
    width: 100%;

    @media screen and (max-width: 600px) {
      margin-top: -20px;
    }

    &-item {
      background-color: #ffffff;
      border-radius: 50%;
      height: 50px;
      width: 50px;
      @media screen and (max-width: 600px) {
        height: 40px;
        width: 40px;
      }
    }
  }
}
</style>

<style lang="scss">
.slides-container {
  max-height: 100vh;
  ul,
  ol {
    padding: 0 !important;
  }
}
</style>
